import Typewriter from "typewriter-effect";
import { marked } from "marked";

import "./index.css";
import HyperSVGLogo from "../HyperSVGLogo";

// Individual Chat Message
const ChatMessage = ({ message, effectEnabled = false, setEffectEnabled }) => {
  return (
    <div className={`chat-message ${message.userType === "gpt" && "chatgpt"}`}>
      <div className="chat-message-center">
        <div className={`avatar ${message.userType === "gpt" && "chatgpt"}`}>
          {message.userType === "gpt" ? (
            <HyperSVGLogo />
          ) : (
            null
          )}
        </div>
        <div
          className={`chat-message-text ${`${
            !message.success ? "error" : ""
          }`}`}
        >
          {message.userType === "gpt" && effectEnabled ? (
            <Typewriter
              options={{
                strings: marked(message.message),
                autoStart: message.message !== "", //start the effect for the valid text
                cursor: message.message !== "" ? "" : "|",
                delay: 2,
                loop: false,
              }}
            />
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: marked(message.message),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
